/*
    🔥 RESALTADO MÍNIMO — sin dependencias

    ⚠️ POR QUÉ NO highlight.js NI prism

    Pesan entre 40 y 300 KB según los lenguajes que metas, y cargan su
    propio tema de colores por CSS. En un panel de administración lo
    que se muestra es JSON de una respuesta, un fragmento de
    configuración o un log: cuatro tipos de token alcanzan.

    Si algún día armás un editor de código de verdad, ahí sí metés la
    librería. Esto es para MOSTRAR, no para editar.

    ⚠️ SE ESCAPA ANTES DE TOKENIZAR

    El texto puede traer < y & de un XML o de un mensaje de error. Si
    no se escapan primero, se inyectan como HTML en el dangerouslySet.
    Es el único lugar del sistema donde eso importa, y por eso está
    acá y no en el componente.
*/

const onEscape = (text) => String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

const KEYWORDS = [
    'const', 'let', 'var', 'function', 'return', 'if', 'else', 'for', 'while',
    'import', 'export', 'from', 'default', 'class', 'extends', 'new', 'await',
    'async', 'try', 'catch', 'finally', 'throw', 'typeof', 'null', 'undefined',
    'true', 'false', 'this',
];

const RULES = [
    // ⚠️ El orden importa: comentarios y cadenas ANTES que todo lo demás,
    //    o una palabra clave adentro de un comentario se pintaría igual.
    { type: 'comment', re: /(\/\/[^\n]*|\/\*[\s\S]*?\*\/|(^|\s)#[^\n]*)/g },
    { type: 'string', re: /("(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|`(?:[^`\\]|\\.)*`)/g },
    { type: 'number', re: /\b(-?\d+\.?\d*(?:e[+-]?\d+)?)\b/gi },
    { type: 'keyword', re: new RegExp(`\\b(${KEYWORDS.join('|')})\\b`, 'g') },
    { type: 'property', re: /("[\w-]+")\s*:/g },
    { type: 'punct', re: /([{}[\]();,])/g },
];

/*
    🔥 Tokeniza en UNA pasada

    Se marcan los tramos ya tomados para que una regla posterior no
    vuelva a pintar adentro de una cadena.
*/
export const onHighlight = (code, language = 'json') => {

    const TEXT = String(code ?? '');

    const TAKEN = new Array(TEXT.length).fill(null);

    const ACTIVE = language === 'text'  ? []  : language === 'json'  ? RULES.filter((r) => r.type !== 'keyword')  : RULES;

    ACTIVE.forEach((rule) => {

        rule.re.lastIndex = 0;

        let match = rule.re.exec(TEXT);

        while (match !== null) {

            const VALUE = match[1] ?? match[0];

            const START = match.index + match[0].indexOf(VALUE);

            const END = START + VALUE.length;

            // 🔥 Solo se pinta si ningún carácter del tramo está tomado
            let free = true;

            for (let i = START; i < END; i += 1) {
                if (TAKEN[i] !== null) { free = false; break; }
            }

            if (free) {
                for (let i = START; i < END; i += 1) TAKEN[i] = rule.type;
            }

            match = rule.re.exec(TEXT);
        }
    });

    // -------------------- 🎯 ARMADO
    let html = '';
    let cursor = 0;

    while (cursor < TEXT.length) {

        const TYPE = TAKEN[cursor];

        let end = cursor;

        while (end < TEXT.length && TAKEN[end] === TYPE) end += 1;

        const CHUNK = onEscape(TEXT.slice(cursor, end));

        html += TYPE   ? `<span class="LStudio__app_code__tk" data-tk="${TYPE}">${CHUNK}</span>`   : CHUNK;

        cursor = end;
    }

    return html;
};

// 🔥 Formatea JSON si se puede; si no, devuelve el original tal cual
export const onPrettyJson = (value, indent = 2) => {

    if (typeof value === 'object') return JSON.stringify(value, null, indent);

    try {
        return JSON.stringify(JSON.parse(String(value)), null, indent);
    } catch {
        return String(value);
    }
};
